<div class="d-inline-flex">
  <ncp-button
    #addMedicationButton
    [options]="btnMOptions()"
  >
    @if (!btnMOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.medications.medicines.src"
        width="18"
        height="18"
        alt="Add Medication"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="devices_form"
      name="devices_form"
      [formGroup]="form"
      #mFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #medicationDesc [(options)]="medicationDescDDOptions" />

      <h5>{{translations.description}}</h5>

      <div class="">
        <label for="atcCode" class="form-label">{{translations.atc_code}}</label>
        <div id="atcCode" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0 mb10px">
          @if(allInfo() && allInfo()?.atc) {
            <div class="row">
              <div class="col-md-3 text-uppercase">{{allInfo()?.atc?.c1}}</div>
              <div class="col-md-9 text-uppercase">{{allInfo()?.atc?.d1}}</div>
            </div>
            <div class="row">
              <div class="col-md-3 text-uppercase">{{allInfo()?.atc?.c3}}</div>
              <div class="col-md-9 text-uppercase">{{allInfo()?.atc?.d3}}</div>
            </div>
            <div class="row">
              <div class="col-md-3 text-uppercase">{{allInfo()?.atc?.c4}}</div>
              <div class="col-md-9 text-uppercase">{{allInfo()?.atc?.d4}}</div>
            </div>
            <div class="row">
              <div class="col-md-3 text-uppercase">{{allInfo()?.atc?.c5}}</div>
              <div class="col-md-9 text-uppercase">{{allInfo()?.atc?.d5}}</div>
            </div>
            <div class="row">
              <div class="col-md-3 text-uppercase">{{allInfo()?.atc?.code}}</div>
              <div class="col-md-9 text-uppercase">{{allInfo()?.atc?.description}}</div>
            </div>
          } @else {
            -
          }
        </div>
      </div>

      <div class="d-flex flex-row gap-2 me-4 mb10px">

        <div class="col-3">
          <label for="activeSubstance" class="form-label">{{translations.active_substance}}</label>
          <div id="activeSubstance" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(allInfo()) {
              <div class="row">
                @for(item of allInfo()?.pas; track $index; let i = $index) {
                  <div class="col-12 text-uppercase">{{item.substance}}</div>
                }
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="col-3">
          <label for="productName" class="form-label">{{translations.product_name}}</label>
          <div id="productName" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(allInfo()) {
              <div class="row">
                <div class="col-12 text-uppercase">{{allInfo()?.pbn?.productName}}</div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="col-3">
          <label for="strength" class="form-label">{{translations.strength}}</label>
          <div id="strength" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(allInfo()) {
              <div class="row">
                <div class="col-12 text-uppercase">{{allInfo()?.pbn?.strength}}</div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="col-3">
          <label for="doseForm" class="form-label">{{translations.dose_form}}</label>
          <div id="doseForm" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(allInfo()) {
              <div class="row">
                <div class="col-12 text-uppercase">{{allInfo()?.pdf?.form}}</div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

      </div>

      <div class="d-flex flex-row gap-2 me-4 mb10px">
        <div class="col-12">
          <span class="form-label me-3">{{ translations.substitutionAllowed }} <span class="required">*</span></span>

          <ncp-radios #substitution [(options)]="substitutionRadiosOptions" />
        </div>
      </div>

      <h5>{{translations.packaging}}</h5>

      <div class="d-flex flex-row gap-2">

        <div class="col-9">
          <ncp-dropdown #packageDesc [(options)]="packageDescDDOptions" />
        </div>

        <div class="col-3 pe-2">
          <ncp-input #noPackages [(options)]="numPackagesInputOptions" />
        </div>

      </div>

      <h5>{{translations.dosage}}</h5>

      <div class="d-flex flex-row gap-2 me-4">

        <div class="col-3">
          <ncp-input #quantityIn [(options)]="quantityInputOptions" />
        </div>

        <div class="col-3">
          <ncp-dropdown #unitIntakeDesc [(options)]="unitsPerIntakeDDOptions" />
        </div>

        <div class="col-3">
          <div class="d-inline-flex flex-nowrap w-100" style="">
            <label [for]="frequencyInputOptions().id" class="form-label col-form-label me-2 align-self-end pb-3">{{translations.every}}</label>
            <ncp-input #frequencyIn class="flex-grow-1" [(options)]="frequencyInputOptions" />
          </div>
        </div>

        <div class="col-3">
          <ncp-dropdown #timeUnitDesc [(options)]="frequencyUnitsDDOptions" />
        </div>

      </div>

      <div class="d-flex flex-row gap-2 me-4">
        <div class="col-3">
          <label for="administrationRoute" class="form-label">{{translations.administration_route}}</label>
          <div id="administrationRoute" class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0">
            @if(allInfo()) {
              <div class="row">
                <div class="col-12 text-uppercase">{{allInfo()?.prt?.route}}</div>
              </div>
            } @else {
              -
            }
          </div>
        </div>

        <div class="col-3">
          <ncp-input #durationIn [(options)]="durationInputOptions" />
        </div>

        <div class="col-3">
          <ncp-dropdown #durationUnitDesc [(options)]="durationUnitsDDOptions" />
        </div>

        <div class="col-3">
          <ncp-date #onSetDate [(options)]="onSetDateOptions" />
        </div>
      </div>

      <div class="d-flex flex-row">
        <div class="col-12">
          <ncp-text-area #instPatients [(options)]="patientInstructionsTAOptions" />
        </div>
      </div>

      <div class="d-flex flex-row">
        <div class="col-12">
          <ncp-text-area #instPharmacists [(options)]="pharmacistInstructionsTAOptions" />
        </div>
      </div>

      <ng-template #medicationTemplate let-value>
        <div class="d-flex flex-row">
          <span class="col-6 text-wrap">{{ value.productName }}</span>
          <span class="col-2 text-wrap">{{ value.atc }}</span>
          <span class="col-4 text-wrap">{{ value.atcdescription }}</span>
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
